(function () {

  function initBodyNeedsSwiper() {

    const slider = document.getElementById(
      'body-needs-swiper-section'
    );

    if (!slider) {
      return;
    }


    if (typeof Swiper === 'undefined') {
      return;
    }


    /*
      * Prevent duplicate initialization
      */
    if (slider.swiper) {
      return;
    }


    const paginationElement = document.getElementById(
      'body-needs-pagination-section'
    );


    /*
      * =========================================
      * SWIPER SETTINGS
      * =========================================
      *
      * Desktop:
      * 5 cards
      * No dragging
      * No sliding
      *
      * Mobile:
      * 1.1 cards visible
      * Swipe enabled
      * Pagination enabled
      * No autoplay
      */

    const swiperOptions = {

      slidesPerView: 5,
      spaceBetween: 16,
      slidesPerGroup: 1,
      loop: false,
      speed: 500,
      autoplay: false,
      allowTouchMove: false,
      simulateTouch: false,
      grabCursor: false,
      watchOverflow: true,

      breakpoints: {
        0: {
          slidesPerView: 'auto',
          spaceBetween: 12,
          slidesPerGroup: 1,
          allowTouchMove: true,
          simulateTouch: true,
          grabCursor: true
        },

        575: {
          slidesPerView: 2.5,
          spaceBetween: 16,
          slidesPerGroup: 1,
          allowTouchMove: true,
          simulateTouch: true,
          grabCursor: true
        },

        1024: {
          slidesPerView: 3,
          spaceBetween: 16,
          slidesPerGroup: 1,
          allowTouchMove: true,
          simulateTouch: true,
          grabCursor: true
        },

        1200: {
          slidesPerView: 5,
          spaceBetween: 16,
          slidesPerGroup: 1,
          allowTouchMove: false,
          simulateTouch: false,
          grabCursor: false
        }
      }
    };


    /*
      * Pagination only if enabled
      */


      if (paginationElement) {

        swiperOptions.pagination = {

          el: paginationElement,

          clickable: true

        };

      }



    /*
      * Initialize Swiper
      */

    new Swiper(
      slider,
      swiperOptions
    );

  }


  /*
    * =========================================
    * INITIAL LOAD
    * =========================================
    */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initBodyNeedsSwiper
    );

  } else {

    initBodyNeedsSwiper();

  }


  /*
    * =========================================
    * SHOPIFY THEME EDITOR
    * =========================================
    */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      if (
        event.detail &&
        event.detail.sectionId === '{{ section.id }}'
      ) {

        initBodyNeedsSwiper();

      }

    }
  );


})();
